import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import AuthenticationService from "./AuthenticationService.js";
import { getAPI } from "../../services/commonService.js";
import { API } from "../../config";

// 권한없을 시 로그인화면 이동
class AuthenticatedRoute extends Component {
  state = {
    result: "PERMITTED",
  };

  componentDidMount() {
    this.checkUrl();
  }

  checkUrl = async () => {
    try {
      const param = {
        userId: AuthenticationService.getLoggedInUserID(),
        branchCd: AuthenticationService.getLoggedInUserBranchCd(),
        url: this.props.location.pathname,
      };
      const res = await getAPI(API.COMMON.CHECK_URL, param);
      this.setState({ result: res.data.result[0].RESULT });
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    if (!AuthenticationService.isUserLoggedIn()) return <Redirect to="/" />;
    if (this.state.result !== "PERMITTED") return <Redirect to="/" />;

    return <Route {...this.props} />;
  }
}

export default AuthenticatedRoute;
